import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

const BASE_URL = `${DATA_SERVICE_BASE_URL}/api/generic-usage-events/metrics`;

/**
 * Generic Usage Event Metrics API
 * Provides analytics endpoints for UI usage tracking.
 */
export const GenericUsageEventMetricsApi = {
  /**
   * Get event counts grouped by event type.
   */
  getEventTypeDistribution: async (startDate, endDate) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    });
    return fetchWithAuth(`${BASE_URL}/event-type-distribution?${params}`);
  },

  /**
   * Get top users by event count.
   */
  getTopUsersByEventCount: async (startDate, endDate, topN = 10) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      topN: topN.toString()
    });
    return fetchWithAuth(`${BASE_URL}/top-users?${params}`);
  },

  /**
   * Get daily or hourly event volume time series.
   */
  getEventVolumeSeries: async (startDate, endDate) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    });
    return fetchWithAuth(`${BASE_URL}/volume-series?${params}`);
  },

  /**
   * Get event counts grouped by feature category.
   */
  getFeatureCategoryDistribution: async (startDate, endDate) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    });
    return fetchWithAuth(`${BASE_URL}/feature-category-distribution?${params}`);
  },

  /**
   * Get summary statistics.
   */
  getSummaryStats: async (startDate, endDate) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    });
    return fetchWithAuth(`${BASE_URL}/summary?${params}`);
  },

  /**
   * Get top features by usage count.
   */
  getTopFeaturesByUsage: async (startDate, endDate, topN = 10) => {
    const params = new URLSearchParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      topN: topN.toString()
    });
    return fetchWithAuth(`${BASE_URL}/top-features?${params}`);
  },

  /**
   * Get user activity timeline (events per hour).
   */
  getUserActivityTimeline: async (userId, startDate, endDate) => {
    const params = new URLSearchParams({
      userId,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    });
    return fetchWithAuth(`${BASE_URL}/user-activity-timeline?${params}`);
  }
};
